import { listShouldShowSeeMore } from 'utils/helpers';
import { useCallback, useMemo, useState } from 'react';
import { Price } from 'feature/countryTabs/shipping/shippingRates/index';

export const useShippingRateCard = ({ prices }: { prices: Price[] }) => {
  const [isAllShown, setIsAllShown] = useState<boolean>(false);

  const isSeeAllVisible = listShouldShowSeeMore(prices, 5);

  const priceList = useMemo(() => {
    return isAllShown ? prices : prices.slice(0, 5);
  }, [isAllShown, prices]);
  const onShowAllStateChange = useCallback(() => {
    setIsAllShown((prevState) => !prevState);
  }, []);

  return {
    isSeeAllVisible,
    isAllShown,
    onShowAllStateChange,
    priceList,
  };
};
